import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/product-categories/:productCategoryId/activate`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const active = {
  post: apiPathFunc(pathBase),
};
